<app-cc-table body #ccTable [transPartKey]="transPartKey"
              [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig"
              [contextMenuConfig]="contextMenuConfig" [(selectedRecord)]="formRecord"
              [(selectedRecords)]="selectedRecords"
              [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading"
              [currentRequest]="tableCurrentRequest"
              (onRowDblClick)="onRowDblClick($event)" (loadRecordsEvent)="needLoadRecords($event)"
              [fieldName]="'id'" [fieldId]="'id'" selectionMode="single" (onContextMenuShow)="refreshContextMenu()"
              [defaultSortField]="'creationDate'" [defaultSortOrder]="1"
>
</app-cc-table>

<app-cc-detail-dialog [formConfig]="formConfig" [transPartKey]="transPartKey"
                      [formRecord]="selectedProfile" [(dialogFormVisible)]="detailDialogVisible"
                      (dialogFormVisibleChange)="detailDialogVisibleChange.emit($event)">
</app-cc-detail-dialog>
